import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { DynamicQuestionComponent } from 'app/assessment/questions/dynamic-question-content/dynamic-question.component';
import { MceSettings } from 'app/core/mce-config/mce-editor-config.constant';
import { UserInterface } from 'app/core/user/models';
import { RecommendationInterface, RecommendationTemplateInterface } from 'app/recommendation/models';
import { RecommendationCategoryMultiInterface } from 'app/recommendation/models/recommendation-category-multi.model';
import { RecommendationCategoryInterface } from 'app/recommendation/models/recommendation-category.model';
import { recommendationItemMullangInterface } from 'app/recommendation/models/recommendation-item-multi.model';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'cz-ergonomic-recommendations',
  templateUrl: './ergonomic-recommendations.component.html',
  styleUrls: ['./ergonomic-recommendations.component.scss'],
})
export class ErgonomicRecommendationsComponent extends DynamicQuestionComponent implements OnInit, OnDestroy {
  @Input() public recommendations$: BehaviorSubject<Readonly<RecommendationInterface[]>>;
  @Input() public recommendationTemplates$: BehaviorSubject<Readonly<RecommendationCategoryInterface[]>>;
  @Input() public saved$: BehaviorSubject<Readonly<boolean>>;
  @Input() public readonly currentUser: UserInterface;
  @Input() public readonly entity: any;
  @Input() public readonly readOnly: boolean;
  @Input() public readonly form: FormGroup;
  @Output() public recommendationAdded: EventEmitter<RecommendationInterface> =
    new EventEmitter<RecommendationInterface>();
  @Output() public recommendationUpdated: EventEmitter<RecommendationInterface> =
    new EventEmitter<RecommendationInterface>();
  @Output() public recommendationRemoved: EventEmitter<RecommendationInterface> =
  new EventEmitter<RecommendationInterface>();
  @Input() public cultureCookie:number;
  @Input() public backupLanguageId:number;
  @Input() public noTranslate:string;
  public tinyApiKey: string = environment.tinyMceKey;
  public ergoDetailsConfig: any = MceSettings.default;
  public templateTextConfig: any = MceSettings.inlineNoControls;
  // State tracking
  public recommendationCategories: RecommendationCategoryInterface[] = [];
  public filteredRecommendationList: Observable<RecommendationTemplateInterface[]>;
  public sortedRecommendation: RecommendationTemplateInterface[] = [];
  public newRecommendation: any;
  public recommendationsAvailable: boolean = false;

  private readonly destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(public dialog: MatDialog) {
    super();
   // this._translateService

  }

  public ngOnInit(): void {
    this.recommendationTemplates$ && this.recommendationTemplates$.pipe(
        takeUntil(this.destroy$))
        .subscribe((list: RecommendationCategoryInterface[]) => {
          if (typeof list === 'undefined') { return; }

          this.recommendationCategories = list.filter((category: RecommendationCategoryInterface) => {
            if(category.recommendations && category.recommendations.length > 0) {
              return category;
            }
          });
          this.recommendationsAvailable = this.recommendationCategories.length > 0;
        });
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  /**
   * Add the currently configured recommendation & priority to the recommendation.
   */
  public addRecommendationItem(item: RecommendationTemplateInterface , category:RecommendationCategoryInterface): void {
    let flag: number = 0;
    let selecttext:string = '';
    let backuptext: string = '';
    /* let selectCategory: string = '';
    let backupcategory: string = ''; */

    item.recommendationItemsMullang.map((list: recommendationItemMullangInterface)=> {
      if (list.languageId === this.cultureCookie && list.text !== '' && list.text !== null && list.text !== undefined && flag === 0) {
        flag= 1;
        selecttext = list.text;
      } else if (list.languageId === this.backupLanguageId && flag === 0) {
        backuptext = list.text;
      }

    });
    if(flag===1) {
      selecttext = selecttext;
    } else {
      selecttext = (backuptext && backuptext !== '') ? backuptext : this.noTranslate;
    }
    const recommendation: RecommendationInterface = {
      id: -1,
      parentRecommendationId: item.id,
      parentRecommendationCategoryTitle: this.getCategoryname(category.categoryMullang),
      text: selecttext,
      relatedAssessmentId: this.entity.id,
      priority: item.priority,
      isEdited:false,
      title: this.getItemTitle(item.recommendationItemsMullang),
      recommendationMullang:[],
    };
    // Alert listeners to change in recommendation.
    this.recommendationAdded.emit(recommendation);
  }

  public forwardRecommendationUpdated(event: RecommendationInterface): void {
    this.recommendationUpdated.emit(event);
  }

  /**
   * Remove the provided recommendation item from the recommendations list.
   *
   * @param item Item to remove from the newRecommendation
   */
  public forwardRecommendationRemoved(item: RecommendationInterface): void {
    // Alert listeners to change in recommendation.
    this.recommendationRemoved.emit(item);
  }
  public getCategoryname(categoryMultilanguage: RecommendationCategoryMultiInterface[]): string {
    let name: string = '';
    let cultureName: string = '';
    let backupName: string = '';
    let flag: number = 0;
    categoryMultilanguage.map((item: RecommendationCategoryMultiInterface)=> {
      if (item.languageId === this.cultureCookie && item.title !== '' && item.title !== null && item.title !== undefined && flag === 0) {
        flag = 1;
        cultureName = item.title;
      } else if (item.languageId === this.backupLanguageId && flag === 0) {
        backupName = item.title;
      }
    });

    if(flag===1) {
      name = cultureName;
    } else {
      name = (backupName && backupName !== '') ? backupName : this.noTranslate;
    }

    return name;
  }


  public getItemTitle(itemMultilanguage: recommendationItemMullangInterface[]): string {
    let name: string = '';
    let cultureName: string = '';
    let backupName: string = '';
    let flag: number = 0;
    itemMultilanguage.map((item: recommendationItemMullangInterface) => {
      if (item.languageId === this.cultureCookie && item.title !== '' && item.title !== null && item.title !== undefined && flag === 0) {
        flag = 1;
        cultureName = item.title;
      } else if (item.languageId === this.backupLanguageId && flag === 0) {
        backupName = item.title;
      }
    });

    if (flag === 1) {
      name = cultureName;
    } else {
      name = (backupName && backupName !== '') ? backupName : this.noTranslate;
    }

    return name;
  }

}
